require('./payrollLoanUploadHeader.scss');

const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
const { formatText, FormattedText } = require('core/i18n').i18n;

// @constants
const { payrollLoanRecordStatus: { requestStatus: { ERROR_DOCUMENTACION } } } = require('../../../../loansConstants/index');

class PayrollLoanUploadHeader extends React.Component {

    render() {
        const { recordStatus } = this.props;

        let title = "payrollLoanDocumentsUpload-title";
        let paragraph1 = __CONTACT_CENTER__ ? 'payrollLoanDocumentsUpload-paragraph1UploadFromWebOrMail' : 'payrollLoanRequestStepThree-payrollLoanRequestStepThree_oneStepLeftTitle';
        let paragraph2 = __CONTACT_CENTER__ ? <FormattedText value="payrollLoanDocumentsUpload-paragraph2UploadFromWebOrMail" /> : null;
        let paragraph3 = "payrollLoanRequestStepThree-payrollLoanRequestStepThree_oneStepLeftParagraph";


        const mailTo = formatText('payrollLoanDocumentsUploa1d-mailTo');
        const mailToLink = (
            <a
                className="ok-link payroll-loan-upload-header__mail-to"
                href={`mailto:${mailTo}`}
                target="_blank"
            >
                {mailTo}
            </a>
        );

        const mailInParagraph1 = (__CONTACT_CENTER__ && recordStatus !== ERROR_DOCUMENTACION) ? mailToLink : null;
        const mailInParagraph2 = (__CONTACT_CENTER__ && recordStatus === ERROR_DOCUMENTACION) ? mailToLink : null;

        if (recordStatus === ERROR_DOCUMENTACION) {
            title = "payrollLoanDocumentsUpload-payrollLoanDocumentErrorTitle";
            paragraph1 = "payrollLoanDocumentsUpload-paragraph1ErrorWithReceipts";
            paragraph2 = __CONTACT_CENTER__ ? <FormattedText value="payrollLoanDocumentsUpload-paragraph2UploadFromWebOrMailWhenDocumentsError" /> : null;
        }

        return (
            <div className="payroll-loan-upload-header">
                <div className="payroll-loan-upload-header__bold-text">
                    <div className="payroll-loan-upload-header__title">
                        <FormattedText value={title} />
                    </div>
                    <div className="payroll-loan-upload-header__message">
                        <div className="payroll-loan-upload-header__bottom-space">
                            <FormattedText value={paragraph1} />
                            {mailInParagraph1}
                        </div>

                        <div className="payroll-loan-upload-header__bottom-space">
                            {paragraph2}
                            {mailInParagraph2}
                        </div>
                    </div>
                    <div className="payroll-loan-upload-header__paragraph-three">
                        <FormattedText value={paragraph3} />
                    </div>
                    {!__CONTACT_CENTER__ && <div>
                        <FormattedText
                            value="payrollLoanDocumentsUpload-payrollLoanDocumentsUpload_uploadMaxSizeParagraph3"
                            className="payroll-loan-upload-header__text"
                        />
                    </div>}
                    <div className="payroll-loan-upload-header__bottom-space no-print-out">
                        <ul>
                            <li>
                                <FormattedText
                                    value="payrollLoanDocumentsUpload-paragraph4"
                                    className="payroll-loan-upload-header__text"
                                />
                                <FormattedText value="payrollLoanRequestStepThree-uploadSizeText" />
                            </li>
                            <li>
                                <FormattedText
                                    value="payrollLoanRequestStepThree-payrollLoanRequestStepThree_uploadMaxSizeParagraph3"
                                    className="payroll-loan-upload-header__text"
                                />
                                <FormattedText value="payrollLoanRequestStepThree-uploadMaxSizeExtensionsText" />
                            </li>
                        </ul>

                    </div>
                </div>
            </div>
        );
    }
}

PayrollLoanUploadHeader.propTypes = {
    recordStatus: PropTypes.string.isRequired
};

module.exports = PayrollLoanUploadHeader;
